import { EffectivePrice } from './effective-price';

export class DuSettings {
  clientId?: string;
  isActive: boolean = false;
  priceHistory?: EffectivePrice[] = [];
  accountIdentifier?: string;
  accountPassword?: string;
  softwareProvider?: string;
  updatedDate?: Date | string;
  updatedBy?: string;

  constructor(clientId: string) {
    this.clientId = clientId;
  }
}
